import { UI } from '@genial/components';
import { Button } from 'native-base';

import { useGlobalAssetContext } from '../../contexts';

export const AssetsRefreshList = () => {
  const { selectedTab, hasSomeLoading, setShouldRefreshAssets, isDesktop } =
    useGlobalAssetContext();

  const handleRefresh = () => {
    if (hasSomeLoading) {
      return;
    }
    setShouldRefreshAssets(true);
  };

  if (!selectedTab.hasRefresher) {
    return <></>;
  }

  return (
    <Button
      testID="refresh-equity-button"
      onPress={handleRefresh}
      isDisabled={hasSomeLoading}
      alignItems="center"
      justifyContent="center"
      variant="secondary"
      bg="white"
      w="52px"
      pr={isDesktop ? 'inline.nano' : '0'}>
      <UI.Icon name="Refresh" size="xxs" />
    </Button>
  );
};
